<div class="d-flex">
  <div class="angle-col">
    <span class="toggle-headlines-btn" *ngIf="item.headlines && item.headlines.length">
      <i class="fa" [ngClass]="item.isOpen ? 'fa-angle-down' : 'fa-angle-right'"></i>
    </span>
  </div>
  <div class="d-inline-flex align-items-center">
    <div class="sym-title-container">
      <a [routerLink]="['/company', item.company.id]" (click)="$event.stopPropagation()"
         class="break-word bold truncate pl-0" target="_blank" [ngClass]="customClass"
         [ngbTooltip]="companyToolTipContent" #tooltip="ngbTooltip" [openDelay]="tooltipOpenDelay"
         tooltipClass="rms-tooltip rms-tooltip-p-0" container="body" placement="right-top"
      >{{ getTitle() }}</a>
      <div *ngIf="displayStrikePrice && item.expiry && item.strikePrice" class='strike-price'>
        <small>
          <em>{{item.expiry | date:'shortDate'}}&nbsp;|&nbsp;{{ item.stockType === 'CALL' ? 'C' : 'P' }}{{ item.strikePrice }}</em>
        </small>
      </div>
    </div>
    <div *ngIf="displayPositionTypeBadge && positionTypeBadge" class="position-type-badge">{{ positionTypeBadge }}</div>
  </div>
</div>

<ng-template #companyToolTipContent>
  <rms-company-tooltip-data [companyId]="item.company.id"
                            [companyFinancial]="item.companyFinancial"
                            [percentFund]="item.percentFund"></rms-company-tooltip-data>
</ng-template>
